import { SVGProps } from "react";

const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "12"}
    height={props.height || "18"}
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.75 16.75L5.75 0.75"
      stroke={props.stroke || "#141B34"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.75 11.75C10.75 11.75 7.06756 16.75 5.74996 16.75C4.43237 16.75 0.75 11.75 0.75 11.75"
      stroke={props.color || "#141B34"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ArrowDown;
